import { BlogsActionTypes } from './blogs-actions';

export const initialState = {
  blogList: [],
  currentPage: 1,
  lastPage: 0,
  loading: false,
  searchList: [],
  searchValue: null,
  searchLoading: false,
  csr: false,
};

function blogsReducer(state = initialState, action: any) {
  switch (action.type) {
    case BlogsActionTypes.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action?.data?.currentPage || 1,
        lastPage: action?.data?.lastPage || 0,
        blogList: initialState.blogList,
      };

    case BlogsActionTypes.SET_EXTENDED_BLOGS:
      return {
        ...state,
        blogList: [...action?.data?.blogList],
        lastPage: action?.data?.lastPage,
        currentPage: action?.data?.currentPage,
        loading: false,
      };

    case BlogsActionTypes.GET_EXTENDED_BLOGS:
      return {
        ...state,
        typeId: action?.data?.typeId,
        currentPage: state.currentPage + 1,
        loading: true,
      };

    case BlogsActionTypes.SET_INITIAL_STATE:
      return {
        ...state,
        blogList: action?.data?.blogList || initialState.blogList,
        lastPage: action?.data?.lastPage || initialState.lastPage,
        currentPage: action?.data?.currentPage || initialState.currentPage,
      };

    case BlogsActionTypes.SET_SEARCH_BLOG_LIST:
      return {
        ...state,
        searchList: action?.data || [],
        searchLoading: false,
      };

    case BlogsActionTypes.GET_SEARCH_BLOG_LIST:
      return {
        ...state,
        searchValue: action?.data?.searchValue || initialState.searchValue,
        searchLoading: true,
      };

    case BlogsActionTypes.SET_CSR_LOADING:
      return {
        ...state,
        csr: true,
      };

    case BlogsActionTypes.SET_SEARCH_LOADING:
      return {
        ...state,
        searchLoading: action?.data?.searchLoading || false,
      };

    default:
      return state;
  }
}

export default blogsReducer;
